import { DefaultSettingsDisplay } from "../../components/analytics/settings/DefaultSettingsDisplay";
import { DefaultSettingsEditor } from "../../components/analytics/settings/DefaultSettingsEditor";
import { SystemFSRSToggle } from "../../components/analytics/settings/SystemFSRSToggle";

export function SystemSettingsPage() {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="h3 mb-2">System FSRS Settings</h1>
      <p className="caption mb-8">
        Manage system-wide FSRS configuration and default settings for all schools.
      </p>

      <div className="space-y-8">
        {/* Global FSRS Configuration */}
        <section>
          <h2 className="h5 mb-4">Global FSRS Configuration</h2>
          <p className="caption mb-4">
            Enable or disable FSRS system-wide. When disabled, no schools will use spaced
            repetition.
          </p>
          <div className="space-y-4">
            <SystemFSRSToggle />
            <DefaultSettingsDisplay />
          </div>
        </section>

        {/* Default Settings Template */}
        <section>
          <h2 className="h5 mb-4">Default Settings for New Schools</h2>
          <p className="caption mb-4">
            These settings will be automatically applied to all schools. Schools with custom
            settings will not be overwritten.
          </p>
          <DefaultSettingsEditor />
        </section>
      </div>
    </div>
  );
}
